import { ContentByIdEndpoint } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  ContentByIdEndpoint,
  React
};